export const STATUSES = Object.freeze({ // read only ...
    IDLE: 'idle',
    LOADING: 'loading',
    ERROR: 'error',
});